import type { PropsWithChildren } from 'react';
import React from 'react';

type RadioGroupProps = {
  // onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const RadioGroup = ({
  // onChange,
  children
}: PropsWithChildren<RadioGroupProps>) => {
  return <div>{children}</div>;
};

export { RadioGroup };
